import { put, cancel, call } from 'redux-saga/effects';
import { generatePath } from 'react-router-dom';

import { isAuthenticated, isRedirectFromSSO } from '@/initializers/awsAmplify/helpers';
import { navigate } from '@/domain/router/redux/reduxActions';
import { isMatchRoute } from '@/domain/router/utils';
import ROUTES_PATH from '@/router/routesPathConfig';
import { isValidBrowser, isMobile, isIE } from '@/lib/systemHelpers/browserHelpers';
import { storage } from '@/lib/storage';

const checkLegalPath = (path: string) => window.location.pathname.startsWith('/mobile') || isMatchRoute(path);

const legalPaths = [
  ROUTES_PATH.NOT_SUPPORTED_MOBILE_BROWSER.absolute,
  ROUTES_PATH.REDIRECT.absolute,
];

const isLegalRoute = () => legalPaths.some((path) => checkLegalPath(path));

// this checks if redirect route is saved in backurl rather than present in window location
// the case is that we are redirected from login app to / and backurl redirection will happen
// later, however we should consider / route allowed for mobile access in case of approval
const isRedirectRoute = () => {
  const backUrl = storage().backUrl().get();
  if (!backUrl) return false;
  return isMatchRoute(ROUTES_PATH.REDIRECT.absolute, backUrl);
};

const isLegalPath = () => isLegalRoute() || isRedirectFromSSO() || isRedirectRoute();

function* stopWithRedirect(redirectUrl: string) {
  yield put(navigate.push(redirectUrl));
  yield cancel();
}

export function* restrictBrowserAccess() {
  // A signed-out user must reach the sign-in redirect; the device check runs after sign-in.
  const isSignedIn: boolean = yield call(isAuthenticated);
  if (!isSignedIn) return;
  if (isIE) {
    yield stopWithRedirect(generatePath(ROUTES_PATH.NOT_SUPPORTED_BROWSER.absolute));
  } else if (!isLegalPath()) {
    if (isMobile) {
      yield stopWithRedirect(generatePath(ROUTES_PATH.NOT_SUPPORTED_MOBILE_BROWSER.absolute, { action: 'restricted' }));
    } else if (!isValidBrowser) {
      yield stopWithRedirect(generatePath(ROUTES_PATH.NOT_SUPPORTED_BROWSER.absolute));
    }
  }
}
